import { createGlobalStyle, styled } from 'styled-components';
import { breakpoints } from "../../../../../utils/styledBreakpoints";

export const GlobalStyle = createGlobalStyle`
    .dx-overlay-wrapper {
        position: fixed !important;
        height: 100% !important;
        transform: none !important;
    }

    .dx-popup-wrapper > .dx-overlay-content {
        border-radius: 15px;
        padding: 20px;
    }

        .dx-popup-wrapper > .dx-overlay-content.dx-popup-flex-height {
            padding: 40px;
            width: 600px !important;
            ${breakpoints("width", "", [{ 991: `unset !important` }])};
        }

    .dx-tooltip-wrapper.dx-popup-wrapper > .dx-overlay-content {
        border-radius: 15px;
        padding: 8px;
        width: unset !important;

        ${breakpoints("width", "", [{ 991: `90% !important` }])};
    }

    .dx-popup-content{
        padding: 0;
    }

    .dx-popup-title { 
        border-bottom: none;
        padding: 0;
        margin-top: 0;
        margin-left: 0;
        margin-bottom: 1.5rem;
    }
    
    .dx-numberbox-spin-container {
        height: 50%;
    }

    .dx-numberbox-spin-up-icon::before {
        content: '\\f014';
    }

    .dx-numberbox-spin-down-icon:before {
        content: '\\f016';
    }

    .dx-radiobutton-icon {
        width: 24px;
        height: 24px;
    }

    .dx-radiogroup .dx-radiobutton:first-child {
        margin-top:0;
    }

    .dx-radiogroup .dx-radiobutton:last-child {
        margin-bottom:0;
    }

    .dx-radiobutton-icon-checked .dx-radiobutton-icon-dot {
        border-width: 2px;
    }

    .dx-radiobutton-icon-checked {
        border-color: var(--primary-active);
    }

    .dx-radiobutton-icon-checked .dx-radiobutton-icon-dot {
        background-color: var(--primary-active)
    }

    .dx-button {
        outline: 1px solid white;
        box-shadow: none !important;
        padding: 0.625rem 1.25rem;
        min-width: unset;
        border: 2px solid var(--button-primary-color);
        background-color: var(--outline-button-color);
        color: var(--outline-button-text-color);
    }

    .dx-button-text {
        font-size: 0.875rem;
    }

    .dx-checkbox-icon {
        width: 22px;
        height: 22px;
        border-radius: 5px;
    }

    .dx-popup-wrapper .tooltip-content {
        max-width: 100%;
        white-space: break-spaces;
        word-wrap: break-word;
    }

    .dx-datebox-wrapper .dx-overlay-content.dx-popup-normal {
        max-width: fit-content;
    }

    .dx-button:focus,
    .dx-button:active {
        border: 2px solid white;
        outline: 2px solid var(--button-primary-color);
    }

    .dx-button.dx-button-normal:focus,
    .dx-button.dx-button-normal:active {
        border: 2px solid white !important;
        outline: 2px solid var(--button-primary-color) !important;
        background: var(--button-primary-color) !important;
        color: var(--button-primary-text-color) !important;
    }

    .dx-button.dx-button-normal:focus .dx-button-text,
    .dx-button.dx-button-normal:active .dx-button-text {
        color: var(--button-primary-text-color) !important;
    }

    .dx-tabs {
        border: 2px solid white;
    }

    .dx-tabs-expanded {
        border-spacing: 2px;
    }

    .dx-tabs.dx-state-focused {
        border: 2px solid var(--button-primary-color);
    }

    .dx-tab {
        border: 2px solid var(--bg-blue-01);
        outline: 2px solid var(--bg-blue-01);
    }

    .dx-tab.dx-tab-selected {
        border: 2px solid var(--button-primary-color);
        outline: 2px solid var(--button-primary-color);
    }

    .dx-tab.dx-state-focused {
        border: 2px solid white;
        outline: 2px solid var(--button-primary-color);
    }

    .dx-item .dx-radio-value-container {
        -webkit-padding-end: 0px;
        padding-inline-end: 0px;
        margin-right: 10px;
    }

    .dx-item.dx-state-focused .dx-radio-value-container {
        border: 1px solid var(--button-primary-color);
    }

    .dx-item.dx-state-focused .dx-radiobutton-icon::after {
        background: unset !important;
        background-color: transparent !important;
    }

    .dx-textbox {
        border: 2px solid white;
    }

    .dx-textbox.dx-state-focused {
        box-shadow: none !important;
        border: 2px solid var(--primary-active);
    }

    .dx-numberbox {
        border: 2px solid white;
    }

    .dx-numberbox.dx-state-focused {
        box-shadow: none !important;
        border: 2px solid var(--primary-active);
    }
`;

export const HouseholdButton = styled.div`
    display: ${props => props.$hidedesktop ? 'none' : 'flex'};
    gap: 0.7rem;
    align-items: center;
    cursor: pointer;
    font-weight: 600;
    font-size: 1.15rem;
    padding: 2px 10px;
    ${breakpoints("display", "", [{ 991: 'flex' }])};
    

    & h6 {
        cursor: pointer;
    }

    h6 {
        font-weight: 600;
        font-size: 1.15rem;
    }
    
    .household-icon {
        height: 100%;
        width: 2rem;
        border-radius: 100%;
        min-height: 2rem;
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
        z-index: 1;
        background-image: var(--household-icon);
    }
`;